import { InfoStepType } from "@web-src/modules/workspace/hooks/useWorkspaceFeatureInfo/useWorkspaceFeatureInfo";
import { useTranslations } from "@jugl-web/utils";
import { ModuleInfoFeatureItem } from "./components/ModuleInfoFeatureItem/ModuleInfoFeatureItem";

export const InfoStep = ({ imageUrl, description, points }: InfoStepType) => {
  const { t } = useTranslations();
  return (
    <div className="relative flex min-h-[646px] flex-col gap-[32px] px-[16px] pt-[32px] font-secondary lg:flex-row xl:gap-[40px] xl:px-[40px]">
      <div className="max-w-[550px] xl:max-w-[692px]">
        <div>
          <img
            key={imageUrl}
            src={imageUrl}
            alt="feature"
            className="h-auto max-w-[550px] xl:max-w-[692px]"
          />
        </div>
      </div>
      <div className="flex w-full max-w-[498px] flex-col gap-8">
        <div>
          <div className="text-xl font-medium text-dark">
            {t({
              id: "workspace-features-page.module-info-layout.key-features",
              defaultMessage: "Key Features:",
            })}
          </div>
          <div className="pt-2 text-left text-base text-[#828282]">
            {description}
          </div>
        </div>
        <div className="flex w-full flex-col gap-4">
          {points?.map((point) => (
            <ModuleInfoFeatureItem
              key={point.title}
              icon={point.icon}
              text={point.title}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
